module.exports = __webpack_public_path__ + "media/react/fonts/fa-regular-400-48880715ae18fa93472af9daa7926fca.svg";